import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserContext } from '../../auth';
import { apiFetch } from '../../api';
import { useUser } from '../../context/UserContext';
import ModuleSelector from '../components/InicioUI';

export default function PrincipalPage({ onLogout }) {
  const user = getUserContext();
  const { empresa, selectProfile } = useUser();
  const navigate = useNavigate();

  const [pinError, setPinError] = useState(false);
  const [validating, setValidating] = useState(false);

  const handleClearError = () => {
    setPinError(false);
  };

  // 1. Navegación directa a Ventas
  const handleSelectVentas = () => {
    navigate('/ventas');
  };

  // 2. Validación de PIN para Admin/Datos
  const handleValidatePin = async (moduleName, inputPin) => {
    if (validating) return;

    setValidating(true);
    setPinError(false);

    try {
      const response = await apiFetch("/api/administradores/validate-pin", {
        method: "POST",
        body: JSON.stringify({ pin: inputPin }),
      });

      if (!response.ok) throw new Error("Error en validación");

      const data = await response.json();
      if (!data.valid) throw new Error("PIN inválido");

      selectProfile({
        id: data.administrador.id,
        administrador_id: data.administrador.id,
        nombre: data.administrador.nombre,
        rol: "Admin",
        empresa_id: empresa?.id ?? user?.empresa_id,
      });
      navigate(`/${moduleName}`);
    } catch (error) {
      console.error("Error PIN:", error);
      setPinError(Date.now());
    } finally {
      setValidating(false);
    }
  };

  return (
    <ModuleSelector
      user={user}
      onLogout={onLogout}
      onSelectVentas={handleSelectVentas}
      onValidatePin={handleValidatePin}
      onClearError={handleClearError}
      externalError={pinError} // Pasamos el error para que vibre el UI
    />
  );
}
